<template>
  <div v-if="orchestrators.length === 0" class="text-center mt-3">
    <IndeterminateSpinner class="fs-2" />
    <p>{{ $t("js.backend.voting_round_report_progress.starting") }}</p>
  </div>
  <template v-else>
    <template v-for="orchestrator in orchestrators">
      <h4 class="mb-3">
        {{ $t(("js.backend.voting_round_report_progress.contest_reference"), {
          contest_reference:
            contestTitle(orchestrator.contestReference)
        }) }}
      </h4>
      <div class="progress mb-5" style="height: 20px">
        <div class="progress-bar progress-bar-striped progress-bar-animated h6 mb-0" role="progressbar"
          :aria-valuenow="progressCurrent(orchestrator)" aria-valuemin="0" :aria-valuemax="progressCount.length"
          :style="{ width: progressPercentage(orchestrator) }">
          {{ $t(`js.result_progress.states.${orchestrator.status}`) }}
        </div>
      </div>
      <hr>
    </template>
  </template>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType, ConferenceContest, E2E, SupportedLocale, WorkflowState } from "@/types";
import { VotingRoundReportChannelSubscription } from "@/channels/e2e/VotingRoundReportChannel";
import IndeterminateSpinner from "../backend/live/IndeterminateSpinner.vue";

export default defineComponent({
  name: "VotingRoundReportProgress",
  components: { IndeterminateSpinner },
  props: {
    initialVotingRoundReport: {
      required: true,
      type: Object as PropType<E2E.VotingRoundReport>,
    },
    progressCount: {
      type: Array as PropType<WorkflowState[]>,
      required: true,
    },
    contests: {
      type: Array as PropType<ConferenceContest[]>,
      required: true,
    },
  },
  data({ initialVotingRoundReport }) {
    return {
      votingRoundReport: initialVotingRoundReport,
      votingRoundReportChannelSubscription: null,
    }
  },
  methods: {
    progressCurrent(orchestrator: E2E.ResultOrchestrator) {
      return 1 + this.progressCount.indexOf(orchestrator.status);
    },
    progressPercentage(orchestrator: E2E.ResultOrchestrator) {
      return `${Math.round(100 * this.progressCurrent(orchestrator) / this.progressCount.length)}%`;
    },
    contestTitle(orchestratorReference: string) {
      const contest = this.contests.find((contest: ConferenceContest) =>
        contest.reference === orchestratorReference);
      return contest.title[this.$i18n.locale as SupportedLocale] || Object.values(contest.title)[0];
    },
  },
  computed: {
    orchestrators() {
      return this.votingRoundReport.resultOrchestrators;
    },
  },
  mounted() {
    this.votingRoundReportChannelSubscription = new VotingRoundReportChannelSubscription(this.votingRoundReport.id, {
      received: (data: any) => {
        this.votingRoundReport = Object.assign(this.votingRoundReport, data.changes);
        if (this.votingRoundReport?.status === "finished") {
          this.votingRoundReport.resultOrchestrators.forEach((ro: E2E.ResultOrchestrator) => ro.status = "finished");
          setTimeout(() => window.location.reload(), 500);
        }
      },
    });
  },
  beforeUnmount() {
    this.votingRoundReportChannelSubscription?.unsubscribe();
  },
});
</script>
